import React, { useState, useEffect } from "react";
import {
  Input,
  Form,
  Col,
  Row,
  Button,
  Select,
  InputNumber,
  Collapse,
  DatePicker,
} from "antd";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import { odata } from "./Helper";
import moment from "moment"

const AkodeAccountTransactionTableFilter = (props) => {
  const [form] = Form.useForm();

  const [bankSelect, setBankSelect] = useState({
    data: [],
    loading: false,
  });
  const [operationTypeSelect, setOperationTypeSelect] = useState({
    data: [],
    loading: false,
  });

  useEffect(() => {
  }, []);

  useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
    }
  }, [props.data]);


  const onFinish = (values) => {
    {
      let query = "";
      const conditions = [];
      if (values.orderId) {
        conditions.push(`Contains(orderId, '${values.orderId}')`);
      }
      if (values.sbuxUserId) {
        conditions.push(`Contains(sbuxUserId, '${values.sbuxUserId}')`);
      }
      if (values.transactionId) {
        conditions.push(`Contains(transactionId, '${values.transactionId}')`);
      }
      if (values.returnPositionVersion) {
        conditions.push(`Contains(returnPositionVersion, '${values.returnPositionVersion}')`);
      }
      if (values.returnTransactionId) {
        conditions.push(`Contains(returnTransactionId, '${values.returnTransactionId}')`);
      }
      if (values.positionVersion) {
        conditions.push(`Contains(positionVersion, '${values.positionVersion}')`);
      }
      if (values.status === 0 || values.status) {
        conditions.push(`statusValue eq ${values.status}`);
      }

      if (values.amountMin) {
        conditions.push(`amount Ge ${values.amountMin}`);
      }

      if (values.amountMax) {
        conditions.push(`amount Le ${values.amountMax}`);
      }
      if (values.transactionDate) {
        const [startDate, endDate] = values.transactionDate;
        conditions.push(odata.dateRangeWithMinute("transactionDate", startDate, endDate));
      }

      if (conditions.length !== 0) {
        query = conditions.join(" and ");
      }
      if (props.onFinishFilter) props.onFinishFilter(query);
    }
  };

  const clearFilter = () => {
    form.resetFields();

    if (props.onClearFilter) {
      props.onClearFilter();
    }
  };

  return (
    <Row id="filterArea" style={{ ...props.style }}>
      <Col span={24}>
        <Collapse>
          <Collapse.Panel header="Filtreleme için tıklayınız.">
            <Form
              name="tenantFilter"
              form={form}
              initialValues={{
                remember: true,
              }}
              layout="vertical"
              onFinish={onFinish}
            >
              <Row style={{ flexDirection: "row" }}>
                  <Col xs={24} md={12} lg={6}>
                  <Form.Item name="orderId" label="Firma İşlem Id :">
                      <Input  placeholder="Firma İşlem Id" />
                    </Form.Item>
                 </Col>

                 <Col xs={24} md={12} lg={6}>
                  <Form.Item name="sbuxUserId" label="User Id :">
                      <Input  placeholder="User Id" />
                    </Form.Item>
                 </Col>

                 <Col xs={24} md={12} lg={6}>
                  <Form.Item name="transactionId" label="İşlem Id :">
                      <Input  placeholder="İşlem Id" />
                    </Form.Item>
                 </Col>

                 <Col xs={24} md={12} lg={6}>
                  <Form.Item name="returnPositionVersion" label="İade İşlem Versiyon :">
                      <Input  placeholder="İade İşlem Versiyon" />
                    </Form.Item>
                 </Col>

                 <Col xs={24} md={12} lg={6}>
                  <Form.Item name="returnTransactionId" label="İade İşlem Id :">
                      <Input  placeholder="İade İşlem Id" />
                    </Form.Item>
                 </Col>

                 <Col xs={24} md={12} lg={6}>
                  <Form.Item name="positionVersion" label="İşlem Versiyon :">
                      <Input  placeholder="İşlem Versiyon" />
                    </Form.Item>
                 </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="transactionDate" label="İşlem Tarihi :">
                    <DatePicker.RangePicker
                      format="DD.MM.YYYY HH:mm"
                      showTime={{ format: 'HH:mm',
                      defaultValue: [moment('00:00', 'HH:mm'), moment('00:00', 'HH:mm')],
                    }}
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item style={{ marginBottom: 0 }} label="Tutar :">
                    <Input.Group>
                      <Row gutter={1} style={{ flexDirection: "row" }}>
                        <Col span={12}>
                          <Form.Item name="amountMin">
                            <InputNumber placeholder="Min" style={{ width: "100%" }} />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item name="amountMax">
                            <InputNumber placeholder="Max" style={{ width: "100%" }} />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Input.Group>
                  </Form.Item>
                </Col>
                {
                  props.isStatusFilter ?
                  <Col xs={24} md={12} lg={6}>
                  <Form.Item name="status" label="Durum :">
                    <Select
                      allowClear
                      showSearch
                      placeholder="Tümü"
                      filterOption={(input, option) =>
                        option.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                    >
                      {[
                        { id: 0, name: "Success" },
                        { id: 1, name: "Failed" },
                        { id: 2, name: "Retry" },
                        { id: 3, name: "Reserved" }
                      ].map((item) => (
                        <Select.Option key={item.id} value={item.id}>
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col> : null
                }
               

            
              </Row>

              <Row style={{ flexDirection: "row" }}>
                <Col span={24} style={{ textAlign: "right" }}>
                  <Button
                    danger
                    size="small"
                    icon={<CloseOutlined />}
                    onClick={() => clearFilter()}
                  >
                    Sıfırla
                  </Button>
                  <Button
                    type="primary"
                    size="small"
                    icon={<SearchOutlined />}
                    style={{ color: "#40a9ff", borderColor: "#40a9ff" }}
                    htmlType="submit"
                  >
                    Filtrele
                  </Button>
                </Col>
              </Row>
            </Form>
          </Collapse.Panel>
        </Collapse>
      </Col>
    </Row>
  );
};
export default AkodeAccountTransactionTableFilter;
